import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import _typeof from "@babel/runtime-corejs2/helpers/typeof";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import classNames from 'classnames';
import Icon from '../Icon';
import { GlobalConfigContext } from '../ConfigProvider';
import ButtonGroup from './ButtonGroup';
// icon图标样式
function renderIcon(props, cls) {
  var marginStyle = {
    marginTop: '-3px',
    marginBottom: '0px',
    marginLeft: props.iconPosition === 'end' ? '4px' : '0px',
    marginRight: props.iconPosition === 'end' ? '0' : '4px'
  };
  if (props.loading) {
    return /*#__PURE__*/React.createElement("i", {
      className: "roo-icon roo-icon-loading ani-spin ".concat(cls),
      style: marginStyle
    });
  } else {
    // return props.icon ? <i className={`roo-icon roo-icon-${props.icon}`} /> : null;
    return props.icon ? ( /*#__PURE__*/React.createElement(Icon, {
      className: cls,
      name: props.icon,
      style: marginStyle
    })) : null;
  }
}
function isUnborderedButtonType(type) {
  return type === 'text' || type === 'brand-text';
}
var rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
function isString(str) {
  return typeof str === 'string';
}
function cloneElement(element, props) {
  if (! /*#__PURE__*/React.isValidElement(element)) return element;
  return /*#__PURE__*/React.cloneElement(element, typeof props === 'function' ? props(element.props || {}) : props);
}
function insertSpace(child, needInserted) {
  // Check the child if is undefined or null.
  if (child === null) {
    return null;
  }
  var SPACE = needInserted ? ' ' : '';
  // strictNullChecks oops.
  if (typeof child !== 'string' && typeof child !== 'number' && isString(child.type) && isTwoCNChar(child.props.children)) {
    return cloneElement(child, {
      children: child.props.children.split('').join(SPACE)
    });
  }
  if (typeof child === 'string') {
    if (isTwoCNChar(child)) {
      child = child.split('').join(SPACE);
    }
    return /*#__PURE__*/React.createElement("span", null, child);
  }
  return child;
}
function spaceChildren(children, needInserted) {
  var isPrevChildPure = false;
  var childList = [];
  React.Children.forEach(children, function (child) {
    var type = _typeof(child);
    var isCurrentChildPure = type === 'string' || type === 'number';
    if (isPrevChildPure && isCurrentChildPure) {
      var lastIndex = childList.length - 1;
      var lastChild = childList[lastIndex];
      childList[lastIndex] = "".concat(lastChild).concat(child);
    } else {
      childList.push(child);
    }
    isPrevChildPure = isCurrentChildPure;
  });
  // Pass to React.Children.map to auto fill key
  return React.Children.map(childList, function (child) {
    return insertSpace(child, needInserted);
  });
}
// TODO: when <a> disabled, preventing event
// const Button: React.FC<ButtonProps> & { Group: React.FunctionComponent<any> } = ({ children, ...restProps }) => {
var InternalButton = function InternalButton(_a, ref) {
  var children = _a.children,
    restProps = __rest(_a, ["children"]);
  var globalConfigValue = React.useContext(GlobalConfigContext);
  var _restProps$autoFocus = restProps.autoFocus,
    autoFocus = _restProps$autoFocus === void 0 ? false : _restProps$autoFocus,
    _restProps$loading = restProps.loading,
    loading = _restProps$loading === void 0 ? false : _restProps$loading,
    _restProps$auto = restProps.auto,
    auto = _restProps$auto === void 0 ? true : _restProps$auto,
    _restProps$type = restProps.type,
    type = _restProps$type === void 0 ? 'normal' : _restProps$type,
    _restProps$status = restProps.status,
    status = _restProps$status === void 0 ? 'normal' : _restProps$status,
    _restProps$icon = restProps.icon,
    icon = _restProps$icon === void 0 ? '' : _restProps$icon,
    _restProps$href = restProps.href,
    href = _restProps$href === void 0 ? '' : _restProps$href,
    _restProps$disabled = restProps.disabled,
    disabled = _restProps$disabled === void 0 ? false : _restProps$disabled,
    _restProps$htmlType = restProps.htmlType,
    htmlType = _restProps$htmlType === void 0 ? 'button' : _restProps$htmlType,
    _restProps$block = restProps.block,
    block = _restProps$block === void 0 ? false : _restProps$block,
    className = restProps.className,
    style = restProps.style,
    _restProps$autoInsert = restProps.autoInsertSpaceInButton,
    autoInsertSpaceInButton = _restProps$autoInsert === void 0 ? false : _restProps$autoInsert,
    _restProps$iconPositi = restProps.iconPosition,
    iconPosition = _restProps$iconPositi === void 0 ? 'start' : _restProps$iconPositi,
    otherProps = __rest(restProps, ["autoFocus", "loading", "auto", "type", "status", "icon", "href", "disabled", "htmlType", "block", "className", "style", "autoInsertSpaceInButton", "iconPosition"]);
  // 上面的otherProps被打包赋值给了button，为了过测试单独处理一些值
  var _restProps$size = restProps.size,
    size = _restProps$size === void 0 ? globalConfigValue.size || 'normal' : _restProps$size,
    _restProps$shape = restProps.shape,
    shape = _restProps$shape === void 0 ? 'default' : _restProps$shape;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    hasTwoCNChar = _React$useState2[0],
    setHasTwoCNChar = _React$useState2[1];
  var buttonRef = ref || /*#__PURE__*/React.createRef();
  var isNeedInserted = function isNeedInserted() {
    return React.Children.count(children) === 1 && !icon && !isUnborderedButtonType(type);
  };
  // btn类型
  var typeClass = {
    normal: "".concat(globalConfigValue.prefixCls, "-btn-primary"),
    hollow: "".concat(globalConfigValue.prefixCls, "-btn-default"),
    weaken: "".concat(globalConfigValue.prefixCls, "-btn-default ").concat(globalConfigValue.prefixCls, "-btn-weaken"),
    dashed: "".concat(globalConfigValue.prefixCls, "-btn-default ").concat(globalConfigValue.prefixCls, "-btn-dashed"),
    text: "".concat(globalConfigValue.prefixCls, "-btn-link"),
    brand: "".concat(globalConfigValue.prefixCls, "-btn-brand"),
    'brand-hollow': "".concat(globalConfigValue.prefixCls, "-btn-outline-brand"),
    'brand-text': "".concat(globalConfigValue.prefixCls, "-btn-link ").concat(globalConfigValue.prefixCls, "-btn-link-brand")
  };
  var sizeClass = {
    large: "".concat(globalConfigValue.prefixCls, "-btn-lg"),
    small: "".concat(globalConfigValue.prefixCls, "-btn-sm"),
    mini: "".concat(globalConfigValue.prefixCls, "-btn-xs"),
    compact: "".concat(globalConfigValue.prefixCls, "-btn-compact"),
    normal: ''
  };
  var shapeClassMap = {
    default: '',
    circle: "".concat(globalConfigValue.prefixCls, "-btn-circle"),
    round: "".concat(globalConfigValue.prefixCls, "-btn-round"),
    square: "".concat(globalConfigValue.prefixCls, "-btn-square")
  };
  // button总体样式
  var btnClassName = function btnClassName() {
    var _classNames;
    return classNames("".concat(globalConfigValue.prefixCls, "-btn"), typeClass[type || 'normal'], sizeClass[size || 'normal'], shapeClassMap[shape || 'default'], (_classNames = {
      disabled: disabled
    }, _defineProperty(_classNames, "".concat(globalConfigValue.prefixCls, "-btn-block"), block), _defineProperty(_classNames, "".concat(globalConfigValue.prefixCls, "-btn-stable"), !auto), _defineProperty(_classNames, "".concat(globalConfigValue.prefixCls, "-btn-").concat(status), status), _defineProperty(_classNames, "focus", autoFocus), _classNames), className);
  };
  var fixTwoCNChar = function fixTwoCNChar() {
    // Fix for HOC usage like <FormatMessage />
    if (!children) {
      return;
    }
    var buttonText = buttonRef.current.textContent;
    if (isNeedInserted() && isTwoCNChar(buttonText)) {
      if (!hasTwoCNChar) {
        setHasTwoCNChar(true);
      }
    } else if (hasTwoCNChar) {
      setHasTwoCNChar(false);
    }
  };
  React.useEffect(fixTwoCNChar, [buttonRef]);
  var kids = children || children === 0 ? spaceChildren(children, isNeedInserted() && autoInsertSpaceInButton) : null;
  /* eslint-disable react/button-has-type */
  return restProps.href ? ( /*#__PURE__*/React.createElement("a", _Object$assign({}, otherProps, {
    href: href,
    className: classNames(btnClassName(), {
      disabled: loading || disabled
    }),
    style: style,
    ref: buttonRef
  }), iconPosition !== 'end' && renderIcon(restProps, !kids ? "".concat(globalConfigValue.prefixCls, "-btn-only-icon") : ''), /*#__PURE__*/React.createElement("span", null, kids), iconPosition === 'end' && renderIcon(restProps, !kids ? "".concat(globalConfigValue.prefixCls, "-btn-only-icon") : ''))) : ( /*#__PURE__*/React.createElement("button", _Object$assign({}, otherProps, {
    disabled: loading || disabled,
    type: htmlType,
    className: btnClassName(),
    style: style,
    ref: buttonRef
  }), iconPosition !== 'end' && renderIcon(restProps, !kids ? "".concat(globalConfigValue.prefixCls, "-btn-only-icon") : ''), /*#__PURE__*/React.createElement("span", null, kids), iconPosition === 'end' && renderIcon(restProps, !kids ? "".concat(globalConfigValue.prefixCls, "-btn-only-icon") : '')));
  /* eslint-enable react/button-has-type */
};
var Button = /*#__PURE__*/React.forwardRef(InternalButton);
Button.displayName = 'Button';
Button.Group = ButtonGroup;
export default Button;